module.exports = "\n<div class=\"btn-group\" data-toggle=\"buttons\">\n  <slot></slot>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-strap/src/radioGroup.vue
// module id = 484
// module chunks = 0